import { ConfigService } from './../../../services/config/config.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { StorageService } from '../../../services/storage/storage.service';
import { ApiService } from '../../../services/apiservice/apiservice.service';
import { BehaviorSubject } from 'rxjs';
import { Router } from '@angular/router';

@Injectable()
export class GalleryViewService {
  private agctrlid: any = '';
  private shard: any = '';
  url = '';

  private fullRecordResults: BehaviorSubject<any> = new BehaviorSubject([]);
  holdingsBS = new BehaviorSubject<any>(null);

  constructor(
    private router: Router,
    private storageService: StorageService,
    private apiService: ApiService,
    private configService: ConfigService,
  ) {}

  setHoldingsBS(value) {
    this.holdingsBS.next(value);
  }

  getHoldingsBS() {
    return this.holdingsBS.asObservable();
  }

  getFullRecord() {
    return this.fullRecordResults.asObservable();
  }

  getFullRecordResults() {
    return this.fullRecordResults.asObservable();
  }
  getAvailableHoldings(data): Observable<any> {
    this.url = this.configService.searchApi + '/holding';
    return this.apiService.post(this.url, data);
  }

  buildRecordDetails() {
    const result = {
      source: this.shard,
      agcontrolid: this.agctrlid,
    };
    return result;
  }
}
